import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { FinaPay_ROUTES } from '../../finapay/finapay.routes';

export const content: Routes = [
  {
    path: '', children: [
      ...FinaPay_ROUTES
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(content, {
    scrollPositionRestoration: 'top'
  })],
  exports: [RouterModule]
})
export class SaredRoutingModule { }
